import React from "react";
import {
  SectionTitle,
  Title,
  Wrapper,
} from "../../../Properties/Details/styles";
import { useParams } from "react-router-dom";

const TransactionDetails = () => {
  const { userId, transactionId } = useParams();
  return (
    <Wrapper>
      <Title>Transaction Detail</Title>
    </Wrapper>
  );
};

export default TransactionDetails;
